import type { ChildDom } from "vanjs-core";
import { t } from "../locale";
import { div, label, option, select } from "./van-tags";

interface OwnerFieldParams {
	getAccess: () => string[];
	getOwner: () => string;
	isDisabled: () => boolean;
	setOwner: (owner: string) => void;
}

export function ownerField(args: OwnerFieldParams): ChildDom {
	return div(
		{ class: "field" },
		label({ class: "label" }, t("deviceSettingsPage.ownerLabel")),
		div(
			{ class: "control" },
			div({ class: "select" }, () =>
				select(
					{
						disabled: () => args.isDisabled(),
						onchange: (e: Event) => {
							if (!(e.target instanceof HTMLSelectElement))
								return;
							args.setOwner(e.target.value);
						},
						value: () => args.getOwner(),
					},
					args.getAccess().map((email) =>
						option({
							selected: email === args.getOwner(),
							text: email,
							value: email,
						}),
					),
				),
			),
		),
	);
}
